// this component use for admin dashboard
import React, { useState, useRef } from "react";

// import components
import Layout from "../components/Layout";
import Sidebar from "../components/Sidebar";

// material
import {
  Card,
  Table,
  Avatar,
  Box,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TableHead from "@mui/material/TableHead";
import EditIcon from "@mui/icons-material/Edit";

// import firebase items
import { db } from "../config/firebaseConfig";
import {
  collection,
  onSnapshot,
  doc,
  deleteDoc,
  query,
  orderBy,
} from "@firebase/firestore";

// moment for timestamp
import Moment from "react-moment";
import EditDialog from "../components/EditDialog";

// row component for single row in table
function Row({ row, removeData }) {
  const ref = useRef(null);
  console.log(row);

  const [open, setOpen] = React.useState(false);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" padding="none">
          <Avatar
            alt={row?.firstName}
            src={row?.featureLink && row?.featureLink[0] && row?.featureLink[0]}
          />
        </TableCell>
        <TableCell>
          <Typography variant="subtitle2" noWrap>
            {row?.name || "--"}
          </Typography>
        </TableCell>
        <TableCell>{row?.email || "--"}</TableCell>
        <TableCell>{row?.brand || "--"}</TableCell>
        <TableCell>{row?.model || "--"}</TableCell>
        <TableCell>{row?.engine || "--"}</TableCell>
        <TableCell>{row?.mileage || "--"}</TableCell>
        <TableCell>{row?.transmission || "--"}</TableCell>
        <TableCell>{row?.fuelType || "--"}</TableCell>
        <TableCell>{row?.gasoline || "--"}</TableCell>

        <TableCell align="right">
          <IconButton ref={ref} onClick={() => setIsOpen(true)}>
            <MoreVertIcon />
          </IconButton>

          <Menu
            open={isOpen}
            anchorEl={ref.current}
            onClose={() => setIsOpen(false)}
            PaperProps={{
              sx: { width: 200, maxWidth: "100%" },
            }}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <EditDialog
              btnOpen={
                <MenuItem
                  sx={{ color: "text.secondary" }}
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <ListItemIcon>
                    <EditIcon width={24} height={24} />
                  </ListItemIcon>
                  <ListItemText
                    primary="Edit"
                    primaryTypographyProps={{ variant: "body2" }}
                    style={{ textAlign: "left" }}
                  />
                </MenuItem>
              }
              id={row?.id}
            />
            <MenuItem
              sx={{ color: "text.secondary" }}
              onClick={() => {
                removeData(row?.id);
                setIsOpen(false);
              }}
            >
              <ListItemIcon>
                <DeleteIcon width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary="Delete"
                primaryTypographyProps={{ variant: "body2" }}
              />
            </MenuItem>
          </Menu>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={19}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h7" gutterBottom component="div">
                <Moment fromNow>{row?.timestamp?.toDate()}</Moment>
              </Typography>
              <Typography variant="h7" gutterBottom component="div">
                <strong>Price- ${row?.price}</strong>
              </Typography>
              <Typography variant="h6" gutterBottom component="div">
                Description
              </Typography>
              <Typography variant="h7" gutterBottom component="div">
                {row?.description}
              </Typography>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default function Data() {
  // this two state for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // this one is storing all data from firebase
  const [data, setData] = React.useState([]);

  // get all data from firebase
  React.useEffect(
    () =>
      onSnapshot(
        query(collection(db, "carPost"), orderBy("timestamp", "desc")),
        (snapshot) => {
          setData(
            snapshot.docs?.map((doc) => {
              return {
                id: doc.id,
                ...doc.data(),
              };
            })
          );
        }
      ),
    [db]
  );

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  // handle change rows per page
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // this function for remove data from firebase
  const removeData = async (id) => {
    const dltDoc = await doc(db, "carPost", id);

    await deleteDoc(dltDoc);
  };

  return (
    <Layout>
      <div className="dashboard-layout">
        <Sidebar />

        <div style={{ width: "100%" }}>
          <Container maxWidth="lg">
            <Card>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell>image</TableCell>
                      <TableCell>User name</TableCell>
                      <TableCell>User Email</TableCell>
                      <TableCell>Brand</TableCell>
                      <TableCell>Model</TableCell>
                      <TableCell>Engine</TableCell>
                      <TableCell>Mileage</TableCell>
                      <TableCell>Transmission</TableCell>
                      <TableCell>Fuel type</TableCell>
                      <TableCell>Gasoline</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Map data and send to table row */}
                  <TableBody>
                    {data &&
                      data
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        ?.map((row) => (
                          <Row
                            key={row?.id}
                            row={row && row}
                            removeData={removeData}
                          />
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={data?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
          </Container>
        </div>
      </div>
    </Layout>
  );
}
